<template>
<div id="app">
<app-header></app-header>
  <transition mode="out-in" name="anima">
<router-view :key="$route.fullPath"></router-view>
  </transition>
</div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<style scoped>
.anima-enter{
  opacity: 0;
}
.anima-enter-active{
  transition: opacity 200ms;
  animation: slidein 200ms ease-out forwards;
}
.anima-leave{

}
.anima-leave-active{
  transition: opacity 200ms;
  opacity: 0;
  animation: slideout 200ms ease-out forwards;
}

@keyframes slidein {
  from{
    transform: translateY(-20px);
  }
  to{
    transform: translateY(0);
  }
}
@keyframes slideout {
  from{
    transform: translateY(0);
  }
  to{
    transform: translateY(20px);
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue